import { useEffect, useState } from 'react'
import InsurancePolicy from './InsurancePolicy'
import { Box, Flex } from 'components/elements'
import { Button } from 'components/button'
import { PageLayoutCss } from '../pages/Insurance'
import { ModalEnum } from 'features/incidents/components/enums'
import CreditCardIcon from '@mui/icons-material/CreditCard'
import ChangePaymentMethod from './ChangePaymentMethod'
import { Tooltip } from '@mui/material'
import { ToolTipcss } from 'features/incidents/components/style'
import useAuth from 'hooks/use-auth'
import MoneyOffIcon from '@mui/icons-material/MoneyOff'
import AttachMoneyIcon from '@mui/icons-material/AttachMoney'
import RecurringPayment from './RecurringPayment'
import SnackBar from 'components/SnackBar'
import { NotificationMessages, TERMINOLOGY } from 'utils/enum'
export const InsurancePage = () => {
  const [openModal, setOpenModal] = useState({
    label: '',
    isOpen: false,
  })
  const doc: Document = document
  const body = doc.querySelector('body')
  useEffect(() => {
    openModal.isOpen ? body?.classList.add('overflow--hidden--modal') : body?.classList.remove('overflow--hidden--modal')
  }, [body?.classList, openModal.isOpen])
  const [notification, setNotification] = useState('')
  const [hasAllServices, setHasALLServices] = useState(false)
  const [recurringStatus, setRecurringStatus] = useState('')
  const { user } = useAuth()

  return (
    <>
      <Box css={{ borderBottom: 1, borderColor: 'divider' }}>
        <Flex css={{ columnGap: '10px', alignSelf: 'flex-end', ...PageLayoutCss }} wrap={'wrap'}>
          {!hasAllServices && (
            <Button
              type="button"
              size="sm"
              bordered="true"
              onClick={() =>
                setOpenModal({
                  label: ModalEnum.ADD_SERVICES,
                  isOpen: true,
                })
              }
            >
              Add Service
            </Button>
          )}
          <Button
            type="button"
            size="sm"
            bordered="true"
            onClick={() =>
              setOpenModal({
                label: ModalEnum.CHANGE_POLICY,
                isOpen: true,
              })
            }
          >
            Change {TERMINOLOGY.warranty.singular}
          </Button>
        </Flex>
        <Flex direction={'row'} justify={'end'} wrap={'wrap'} css={{ my: '1rem' }}>
          <Flex justify={'end'} css={{ columnGap: '10px', alignSelf: 'flex-end', ...PageLayoutCss }} wrap={'wrap'}>
            {user?.stripePaymentId && (
              <Tooltip
                PopperProps={{ sx: ToolTipcss }}
                title={
                  <Box as="span" css={{ color: '$black' }}>
                    {user?.isAutoSubscriptionEnabled ? ' Disable Recurring Payement ' : 'Enable Recurring Payement '}
                  </Box>
                }
                placement="bottom"
                enterTouchDelay={0}
              >
                <Button
                  type="button"
                  bordered="true"
                  css={{ minWidth: 50 }}
                  onClick={() =>
                    setOpenModal({
                      label: ModalEnum.RECURRING_PAYMENT,
                      isOpen: true,
                    })
                  }
                >
                  {user?.isAutoSubscriptionEnabled ? <MoneyOffIcon /> : <AttachMoneyIcon />}
                </Button>
              </Tooltip>
            )}

            <Tooltip
              PopperProps={{ sx: ToolTipcss }}
              title={
                <Box as="span" css={{ color: '$black' }}>
                  Change Card Details
                </Box>
              }
              placement="bottom"
              enterTouchDelay={0}
            >
              <Button
                type="button"
                css={{ minWidth: 50 }}
                bordered="true"
                onClick={() =>
                  setOpenModal({
                    label: ModalEnum.CHANGE_PaymentMethod,
                    isOpen: true,
                  })
                }
              >
                <CreditCardIcon />
              </Button>
            </Tooltip>
          </Flex>
        </Flex>
      </Box>
      <InsurancePolicy openModal={openModal} setOpenModal={setOpenModal} setHasALLServices={setHasALLServices} setNotification={setNotification} />
      {openModal.label === ModalEnum.CHANGE_PaymentMethod && <ChangePaymentMethod openModal={openModal} setOpenModal={setOpenModal} setNotification={setNotification} />}
      {openModal.label === ModalEnum.RECURRING_PAYMENT && (
        <RecurringPayment
          openModal={openModal}
          setOpenModal={setOpenModal}
          setRecurringStatus={setRecurringStatus}
          setNotification={setNotification}
          subscriptionStatus={user?.isAutoSubscriptionEnabled}
        />
      )}

      {/* all notification over here */}
      <SnackBar
        open={notification === ModalEnum.RECURRING_PAYMENT}
        onClose={() => {
          setNotification('')
        }}
        text={`Recurring Payment ${recurringStatus}d sucessfully`}
        severity={'success'}
      />
      <SnackBar
        open={notification === ModalEnum.CHANGE_PaymentMethod}
        onClose={() => {
          setNotification('')
        }}
        text={NotificationMessages.Change_PaymentMethod}
        severity={'success'}
      />

      <SnackBar open={notification === ModalEnum.CHANGE_POLICY} onClose={() => setNotification('')} text={NotificationMessages.CHANGE_POLICY} severity={'success'} />
      <SnackBar
        open={notification === ModalEnum.CHANGE_PaymentMethod}
        onClose={() => {
          setNotification('')
        }}
        text={NotificationMessages.Change_PaymentMethod}
        severity={'success'}
      />
      <SnackBar open={notification === ModalEnum.ADD_SERVICES} onClose={() => setNotification('')} text={NotificationMessages.ADD_SERVICE} severity={'success'} />
    </>
  )
}
